import React, { Suspense, lazy, useState, useEffect } from 'react';
import ScrollProgress from './home/components/marketing/ScrollProgress';
import HeroSection from './home/components/marketing/HeroSection';
import VisionSection from './home/components/marketing/VisionSection';
import SupportChatLoader from '../utils/SupportChatLoader';
import FreeTrialModal from '../components/FreeTrialModal';

// Lazy load heavy components
const PathSystemSection = lazy(() => import('./home/components/marketing/PathSystemSection'));
const ExploreSection = lazy(() => import('./home/components/marketing/ExploreSection'));
const ProjectPortfolioSection = lazy(() => import('./home/components/marketing/ProjectPortfolioSection'));
const AIEditorSection = lazy(() => import('./home/components/marketing/AIEditorSection'));
const AIVisionPrinciplesSection = lazy(() => import('./home/components/marketing/AIVisionPrinciplesSection'));
const AilaChatSection = lazy(() => import('./home/components/marketing/AilaChatSection'));
const TalentCupSection = lazy(() => import('./home/components/marketing/TalentCupSection'));
const HubSection = lazy(() => import('./home/components/marketing/HubSection'));
const ExtraPackagesSection = lazy(() => import('./home/components/marketing/ExtraPackagesSection'));
const PioneerSection = lazy(() => import('./home/components/marketing/PioneerSection'));
const CTASection = lazy(() => import('./home/components/marketing/CTASection'));

// Simple loading fallback
const SectionLoader = () => (
  <div style={{ minHeight: '400px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    <div style={{ 
      width: '40px', 
      height: '40px', 
      border: '4px solid #f3f4f6', 
      borderTop: '4px solid #6c5dd3',
      borderRadius: '50%',
      animation: 'spin 1s linear infinite'
    }} />
  </div>
);

const Home = () => {
  const [showFreeTrialModal, setShowFreeTrialModal] = useState(false);

  useEffect(() => {
    // İlk ziyareti kontrol et
    const hasVisited = localStorage.getItem('talent14_visited');
    
    if (!hasVisited) {
      // 1.5 saniye sonra modal'ı göster (sayfa yüklendikten sonra)
      const timer = setTimeout(() => {
        setShowFreeTrialModal(true);
        localStorage.setItem('talent14_visited', 'true');
      }, 1500);
      
      return () => clearTimeout(timer);
    }
  }, []);

  const handleCloseModal = () => {
    setShowFreeTrialModal(false);
  };

  return (
    <div style={{overflow:"hidden"}}>
      {showFreeTrialModal && <FreeTrialModal onClose={handleCloseModal} />}
      <ScrollProgress />
      {/* 1. Ana vurucu bir giriş */}
      <HeroSection />
      {/* 2. Geleceğin Eğitim Platformu */}
      <VisionSection />
      
      {/* Lazy loaded sections for better performance */}
      <Suspense fallback={<SectionLoader />}>
        {/* 3. Kademeli Öğrenme (Patika) */}
        <PathSystemSection />
        {/* 4. AI-LA --> Bireyselleştirilmiş Yapay Zeka Deneyimi */}
        <AilaChatSection />
        {/* 5. AI-14 --> Etik Yapay Zeka (+50 den fazla model…) */}
        {/* 6. AI-Code --> Yapay Zeka Destekli Kodlama */}
        <AIEditorSection />
        {/* 6.5. TALENT14 Yapay Zekâ Vizyonu ve Kurumsal Duruş İlkeleri */}
        <AIVisionPrinciplesSection />
        {/* 7. Keşfet */}
        <ExploreSection />
        {/* 8. Proje Portföyü */}
        <ProjectPortfolioSection />
        {/* 9. Topluluk Kültürü (Hub) */}
        <HubSection />
        {/* 10. TalentCup */}
        <TalentCupSection />
        {/* 11. Planlar */}
        <ExtraPackagesSection />
        {/* 12. Eğitimde Yapay Zeka'nın öncüsü */}
        <PioneerSection />
        {/* 13. Geleceğe hazır mısınız? */}
        <CTASection />
      </Suspense>
      
      <SupportChatLoader showWidget={true} />
    </div>
  );
};

export default Home;
